import React from 'react';

interface ShopsIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Tiendas"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Un edificio/comercio con techo triangular
 * - Forma de casa/tienda tradicional con frontón
 * - Puerta central en la parte inferior
 * - Ventanas laterales simétricas
 * - Techo inclinado que forma un triángulo en la parte superior
 * - Representa una tienda física o comercio
 * - Estilo minimalista, líneas limpias
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const ShopsIcon: React.FC<ShopsIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={(size * 134) / 150}
      viewBox="0 0 150 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.76972 12.4641C9.82414 5.36875 16.3447 0.5 23.7585 0.5H126.182C133.596 0.5 140.116 5.36875 142.201 12.4641L149.168 36.2734C151.698 44.8828 148.245 53.4922 141.694 58.3312V112.125C141.694 123.941 132.107 133.5 120.257 133.5H29.7431C17.893 133.5 8.30566 123.941 8.30566 112.125V58.3312C1.75532 53.4922 -1.6985 44.8828 0.832317 36.2734L7.76972 12.4641ZM110.908 5.25L113.796 39.9547C113.796 39.9547 113.796 39.9547 113.796 39.9844L114.064 43.25C114.749 51.2953 121.478 57.5 129.606 57.5C139.997 57.5 147.471 47.5547 144.582 37.6094L137.615 13.8C136.127 8.72344 131.482 5.25 126.182 5.25H110.908ZM109.062 40.3406L106.114 5.25H77.3522V41.6766C77.3522 50.4344 84.4682 57.5 93.2218 57.5C102.511 57.5 109.806 49.5734 109.062 40.3406ZM74.9702 51.2656C71.5164 57.7969 64.6386 62.25 56.7186 62.25C48.7391 62.25 41.891 57.7672 38.4372 51.2359C35.0429 57.7969 28.1651 62.25 20.3345 62.25C17.7441 62.25 15.3026 61.775 13.0398 60.9141V90.75H136.901V60.9141C134.668 61.775 132.196 62.25 129.606 62.25C121.775 62.25 114.898 57.8266 111.503 51.2359C108.049 57.7375 101.201 62.25 93.2218 62.25C85.3019 62.25 78.424 57.7969 74.9702 51.2656ZM72.5883 5.25H43.8263L40.8787 40.3406C40.1046 49.5734 47.429 57.4703 56.7186 57.4703C65.502 57.4703 72.5883 50.375 72.5883 41.6469V5.22031V5.25ZM23.7585 5.25C18.4587 5.25 13.8139 8.72344 12.3252 13.8L5.358 37.6094C2.44013 47.5547 9.94324 57.5 20.3345 57.5C28.4331 57.5 35.1918 51.2953 35.8766 43.25L36.1446 39.9844L39.0327 5.27969H23.7585V5.25ZM13.0398 95.5V112.125C13.0398 121.298 20.5131 128.75 29.7133 128.75H120.227C129.427 128.75 136.901 121.298 136.901 112.125V95.5H13.0398Z"
        fill="currentColor"
      />
    </svg>
  );
};

